export const PARTIAL_PAYMENT_TRIGGER = 'partial_payment_trigger';
export const PAYMENT_CONTINUED = 'payment_continued';
export const CONTINUED_TRANSACTION = 'continued_transaction';